import React from 'react';
import useTranslation from 'Hooks/useTranslation';
import { SPANISH } from 'Constants/General';
import { LocalizationProvider, CalendarPicker, PickersDay } from '@mui/x-date-pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import Tooltip from '@mui/material/Tooltip';
import { useStyles } from './style';

import('moment/locale/es');

export default function SubComponentsPickers({ events = [] }) {
  const { DatePickerDay, CalendarPickerStyle, DatePickerDaySelect } = useStyles();
  const date = new Date();
  const Month = moment(date).format('MM');
  const { language } = useTranslation();

  const filteredEvents = events.filter(event => new Date(`${event?.date} 00:00`).getMonth() === date.getMonth());

  const names = filteredEvents.map(event => event.name);
  const days = filteredEvents.map(event => event.date.slice(8, 10));

  if (language !== SPANISH) import('moment/locale/en-gb');

  const pickerDay = ({ day, className, selected = false, disabled = true }) => (
    <PickersDay
      // eslint-disable-next-line no-underscore-dangle
      key={day._d}
      day={day}
      onDaySelect={() => {}}
      outsideCurrentMonth={false}
      selected={selected}
      disabled={disabled}
      className={className}
    />
  );

  const renderDay = day => {
    const currentDay = moment(day).format('DD');
    const currentMonth = moment(day).format('MM');
    if (Month !== currentMonth) return pickerDay({ day, className: DatePickerDay });

    const index = days.indexOf(currentDay);
    const selected = index !== -1;

    if (selected) {
      return (
        // eslint-disable-next-line no-underscore-dangle
        <Tooltip title={names[index]} key={day._d}>
          {pickerDay({
            day,
            selected: true,
            disabled: false,
            className: DatePickerDaySelect,
          })}
        </Tooltip>
      );
    }
    return pickerDay({ day, className: DatePickerDay });
  };

  return (
    <LocalizationProvider dateAdapter={MomentUtils} dateLibInstance={moment}>
      <CalendarPicker
        key={1}
        disabled
        renderDay={renderDay}
        onChange={() => {}}
        className={CalendarPickerStyle}
        components={{ LeftArrowIcon: 'div', RightArrowIcon: 'div' }}
      />
    </LocalizationProvider>
  );
}
